import { useEffect, useRef, useState } from 'react';

import { storageKeys } from 'config/settings.json';
import StorageHandler from 'config/StorageHandler';
import { ensureCurrentAppStorage } from 'helpers/ensureCurrentAppStorage';

import { useSessionManager } from 'hooks/useSessionManager';
import { sessionManager } from 'hooks/useSessionManager/sessionManager';

const sessionKey = storageKeys.sessionId;

export const useSessionTracking = () => {
  const [, setUser] = useState(null);
  const { startSession } = useSessionManager();
  const initializedRef = useRef(false);
  const appId = Number(import.meta.env.VITE_APP_ID);

  useEffect(() => {
    const checkSession = async () => {
      await ensureCurrentAppStorage();

      const storedUser = await StorageHandler.load(storageKeys.user);
      setUser(storedUser);

      if (!storedUser?.email) {
        initializedRef.current = false;
        return;
      }

      if (initializedRef.current) return;
      initializedRef.current = true;

      const existingSessionId = await StorageHandler.load(sessionKey);
      console.info('Existing session ID:', existingSessionId);

      if (!existingSessionId) {
        console.info('Starting new session for user:', storedUser.email);
        void startSession({ app_id: appId, email: storedUser.email, device: 'pc' })
          .then(() => {
            console.info('Session started successfully');
          })
          .catch((err) => {
            console.error('Session start failed', err);
          });
      } else {
        console.info('Restoring session for user:', storedUser.email);
        void sessionManager.resumeSessionUpdates();
      }
    };

    void checkSession();
  }, [startSession, appId]);
};
